import { Fragment } from "react";
import { Tab } from "@headlessui/react";

interface RecordingTypeTabProps {
  disabled?: boolean;
  text: string;
  Icon: React.ComponentType<{ className?: string }>;
  isBeta?: boolean;
}

export function RecordingTypeTab({ disabled, text, Icon, isBeta }: RecordingTypeTabProps) {
  return (
    <Tab as={Fragment} disabled={disabled}>
      {({ selected }) => (
        <button
          type="button"
          className={`flex flex-row gap-2 items-center px-2 py-2 border-b-2 transition-all duration-200 focus:outline-none ${
            selected
              ? "text-blue-600 border-blue-600 bg-white"
              : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300 hover:bg-gray-50"
          }`}
        >
          <Icon
            className={`h-4 w-4 ${
              selected ? "text-blue-600" : "text-gray-500"
            }`}
          />
          <h3
            className={`text-base font-semibold leading-6 ${
              selected ? "text-blue-600" : "text-gray-500"
            }`}
          >
            {text}
          </h3>
          {isBeta && <div className='text-white rounded-lg px-2 py-0.5 bg-blue-900 text-xs'>Beta</div>}
        </button>
      )}
    </Tab>
  );
}
